import clone from 'ramda/src/clone'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import previewModule from '@/store/modules/preview.module'
import toaster from '@/utils/toaster'
import botModule from '@/store/modules/bot.module'
import { BOT_TYPES } from '@/utils/bot.constants'

class ErrorUtils {

  handleConversationDesignerError(err, botId, stateTree, conversationType, routeFullPath) {
    const data = clone(err.response?.data)

    if (data?.code?.includes('validation')) {
      if (data?.details?.description.includes('<botId>')) {
        data.details.description = data.details.description.replace('<botId>', botId)
      }

      if (botModule.getBot().type === BOT_TYPES.EMAIL) {
        toaster.error(data.details.description)
      } else {
        previewModule.error.set(data.details)
        chatBubbleModule.highlightError(data, stateTree)
      }
      return
    }

    if (data?.actionId) {
      toaster.error(data.description)
      previewModule.error.set(data)
      return
    }

    const errorMessage = data?.details?.errors?.[0]?.message || err.message
    const message = this.resolveMessage({ message: errorMessage }, conversationType, routeFullPath)
    toaster.error(message)
    previewModule.error.set(message)
  }

  resolveMessage(err, chatbotReplacement, currentUrl) {
    const validationErrors = err.response?.data?.details?.errors
    if (validationErrors) {
      return validationErrors[0].message
    }

    if (typeof err === 'object' && err.message && err.message.trim().startsWith('Chatbot couldn\'t be saved.')) {
      return err
        .replace('separate tab', `<a href="${currentUrl}" target="_blank">separate tab</a>`)
        .replace('Chatbot', chatbotReplacement)
    }

    return typeof err === 'object' ? err.message : err
  }

  resolveDuplicateExampleMessage(errorMessage) {
    const errorMesssageStart = errorMessage.replace('already exists for ', '')
    const isTruncated = errorMesssageStart.length > 300
    const toastBody = {}
    toastBody.content = isTruncated ? errorMesssageStart.substring(0, 300) + '…"' : errorMesssageStart
    if (isTruncated) toastBody.fullContent = errorMesssageStart
    return toastBody
  }

  resolveFileUploadMessage(err) {
    return err.response?.data
  }

  isIndexCreateUpdateError(errorMessage) {
    return errorMessage.includes('Knowledge Base') ||
      errorMessage.includes('Header Key') ||
      errorMessage.includes('Header Value') ||
      errorMessage.includes('Web Page') ||
      errorMessage.includes('XML Feed URL') ||
      errorMessage.includes('Source') ||
      errorMessage.includes('Tag') ||
      errorMessage.includes('File URL must be a valid URL.') ||
      errorMessage.includes('File exceeds') ||
      errorMessage.includes('File not found') ||
      errorMessage.includes('File mimeType')
  }
}

export default new ErrorUtils()
